// extracted by mini-css-extract-plugin
export default {"faqBox":"styles_faqBox__mAXwu","faqTitle":"styles_faqTitle__uaXS4","faqQuestion":"styles_faqQuestion__41EJg","faqAnswer":"styles_faqAnswer__JkaCt"};